// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2MlHk","notes":"Notes_notes__1Mvgr","note":"Notes_note__i4PZL","markdown":"Notes_markdown__2GSWV"};